import { render, staticRenderFns } from "./StudentLeaveSubCreate.vue?vue&type=template&id=39c197ac&scoped=true&"
import script from "./StudentLeaveSubCreate.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveSubCreate.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveSubCreate.vue?vue&type=style&index=0&id=39c197ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c197ac",
  null
  
)

export default component.exports